module.exports = __webpack_public_path__ + "static/media/4.9ad00ff1.JPG";